import { render, staticRenderFns } from "./WorkingHoursManagerComp.vue?vue&type=template&id=56e1e49d&scoped=true&"
import script from "./WorkingHoursManagerComp.vue?vue&type=script&lang=js&"
export * from "./WorkingHoursManagerComp.vue?vue&type=script&lang=js&"
import style0 from "./WorkingHoursManagerComp.vue?vue&type=style&index=0&id=56e1e49d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e1e49d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VContainer,VIcon,VSheet,VSnackbar,VTab,VTabItem,VTabs,VTabsSlider})
